import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Moment from 'moment'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import EditIcon from '@material-ui/icons/Edit'
import AddIcon from '@material-ui/icons/Add'
import Divider from '@material-ui/core/Divider'
import DeleteIcon from '@material-ui/icons/Delete'
import Tooltip from '@material-ui/core/Tooltip'
import CardActions from '@material-ui/core/CardActions'
import SubscriptionCardSkeleton from './subscription-card-skeleton'
import DataGraph from './data-graph'
import Y from '../../../y18n'
import * as subscriptionActions from '../../../store/subscriptions'
import Styles from '../../../common/styles'

const mapStateToProps = state => ({
  subscriptions: state.subscriptions
})

const mapDispatchToProps = dispatch => ({
  subscriptionActions: bindActionCreators(subscriptionActions, dispatch)
})

class SubscriptionCards extends Component {
  state = {
    numberOfSkeletons: ''
  }

  componentDidMount () {
    this.props.subscriptionActions.getSubscriptions()
    const numberOfSkeletons = localStorage.getItem('subscriptions')
    numberOfSkeletons && numberOfSkeletons > 1
      ? this.setState({ numberOfSkeletons: numberOfSkeletons })
      : this.setState({ numberOfSkeletons: 1 })
  }

  render () {
    const { classes, subscriptions, subscriptionActions } = this.props
    return (
      <div>


        <div className={classes.textRow}>
      

          <Typography variant='title' style={{ fontSize: '32px' }}>
            {Y`My subscriptions`}
          </Typography>

          <Button variant='raised' style={{ color: 'white', backgroundColor: 'green' }} onClick={() => subscriptionActions.setNew()}>
        
        {Y`Add a subscription`}
        </Button>


        </div>

 
  



        <div className={classes.cardContainer}>
          {subscriptions.loading
            ? <SubscriptionCardSkeleton count={this.state.numberOfSkeletons} />
            : [
                subscriptions.items.length > 0
                ? subscriptions.items.map((subscription, index) => this.renderSubscriptionCard(subscription, index))
                : <div className={classes.textRow}>
                  <Typography variant='body2'>
                    {Y`No subscriptions found`}
                  </Typography>
                </div>, 
                subscriptions.items.length > 1 && subscriptions.items.length%2 != 0 
                  ? <div style={{
                      flex: '1 1 auto',
                      maxWidth: '600px',
                      width: '100%',
                      height: '0',
                      marginBottom: '20px',
                      marginLeft: '10px',
                      marginRight: '10px'}}></div> 
                  : null
              ]}
        </div>
      </div>
    )
  }

  renderSubscriptionCard (subscription, index) {
    const { classes } = this.props
    return (
      <Card key={subscription.id} className={classes.subscriptionCard}>
        <CardContent>
          <div className={classes.header}>
            <Avatar
              aria-label='Active'
              className={subscription.status === 'Active' ? classes.avatarActive : classes.avatarPaused}
            >
              #{index + 1}
            </Avatar>
            <div className={classes.headerTitle}>
              <Typography variant='title' style={{ marginBottom: '4px' }}>
                {subscription.name}
                {' '}
                {subscription.status === 'Active'
                  ? <span style={{ color: 'forestgreen' }}>
                      ({Y`${subscription.status}`}){' '}
                  </span>
                  : <span style={{ color: 'red' }}>
                      (
                      {Y`${subscription.status}`}
                      )
                      {' '}
                    <span style={{ fontSize: '16px', foneWight: 'normal' }}>
                      {subscription.endDate < Moment(new Date()).format('YYYY-MM-DD')
                          ? <span>- {Y`The end date has passed`}</span>
                          : subscription.dataUsed > subscription.dataLimit
                              ? <span>
                                  - {Y`Data usage exceeded data limit`}{' '}
                              </span>
                              : ''}
                    </span>
                  </span>}
              </Typography>
              <Typography variant='body2' className={classes.headerTitleSub}>
                {Y`Product`}: {subscription.productName}
              </Typography>
              <Typography variant='body2' className={classes.headerTitleSub}>
                {Y`Valid`}
                :
                {' '}
                {Moment(subscription.startDate).format('YYYY-MM-DD')}
                {' - '}
                {Moment(subscription.endDate).format('YYYY-MM-DD')}
              </Typography>
            </div>
          </div>
          <div className={classes.subSummary}>
            <div className={classes.subSummaryItem}>
              <Typography variant='body2'>{subscription.imsi}</Typography>
              <Typography variant='body1' className={classes.headerTitleSub}>
                {Y`The card's IMSI number`}
              </Typography>
              <Tooltip
                title={Y`Your Simcard has a unique number which is called an IMSI number. You will need this to renew your subscription`}
                placement='bottom'
                classes={{ tooltip: classes.popper }}
                disableTouchListener
              >
                <Typography variant='body2' className={`${classes.themeLink}`}>
                  {Y`What is this?`}
                </Typography>
              </Tooltip>
            </div>
            <div className={classes.subSummaryItem}>
              <Typography variant='body2'>+{subscription.msisdn}</Typography>
              <Typography variant='body1' className={classes.headerTitleSub}>
                {Y`The card's phone number`}
              </Typography>
              <Tooltip
                title={Y`Your Simcard has a phone number which makes it possible to change settings remotely by sending a text message`}
                placement='bottom'
                classes={{ tooltip: classes.popper }}
                disableTouchListener
              >
                <Typography variant='body2' className={`${classes.themeLink}`}>
                  {Y`What is this?`}
                </Typography>
              </Tooltip>
            </div>
          </div>
        </CardContent>
        <div className={classes.media}>
          { subscription.status !== 'Terminated'  ? <DataGraph subscription={subscription} /> : null }          
        </div>
        <CardContent style={{ marginTop: '0px', paddingTop: '15px' }}>
          <div className={classes.subSummary} style={{ marginTop: '0px' }}>
            <div className={classes.subSummaryItem}>
              <Typography variant='body2'>
                { subscription.status !== 'Terminated' ? subscription.dataUsed.toFixed(0) : 0 } MB
              </Typography>
              <Typography variant='body1' className={classes.headerTitleSub}>
                {Y`Remaining data`}
              </Typography>
            </div>
            {subscription.smsStatus === 'Active'
              ? <div className={classes.subSummaryItem}>
                <Typography variant='body2'>
                  {subscription.smsUsedCount}
                  </Typography>
                <Typography variant='body1' className={classes.headerTitleSub}>
                  {Y`SMS used`}
                </Typography>
              </div>
              : ''}
          </div>
        </CardContent>
        <Divider style={{ marginTop: '20px' }} />
        <CardActions style={{ display: 'flex' }}>
          <Button
            style={{ flex: '1 1 auto', marginRight: '10px', padding: 0 }}
            onClick={() => this.props.changeUrl(`subscriptions/renew/${subscription.imsi}`)}
          >
            <AddIcon style={{ marginRight: '10px', color: 'forestgreen' }} />
            {Y`Renew`}
          </Button>
          <Button
            style={{ flex: '1 1 auto', marginRight: '10px', padding: 0 }}
            onClick={() => this.props.subscriptionActions.setActive(subscription)}
          >
            <EditIcon style={{ marginRight: '10px', color: 'orange' }} />
            {Y`Edit`}
          </Button>
          <Button
            style={{ flex: '1 1 auto', marginRight: '10px', padding: 0 }}
            onClick={() => this.props.subscriptionActions.setDelete(subscription)}
          >
            <DeleteIcon style={{ marginRight: '10px', color: 'red' }} />
            {Y`Delete`}
          </Button>
        </CardActions>
      </Card>
    )
  }
}

SubscriptionCards = connect(mapStateToProps, mapDispatchToProps)(SubscriptionCards)
export default withStyles(Styles)(SubscriptionCards)



// WEBPACK FOOTER //
// ./src/pages/subscriptions/containers/subscription-cards.js